module.exports = __webpack_public_path__ + "img/cloud-arrow-down.3ffb3b04.svg";